module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/003087270c5c979459b55b9400c26543.png";